export const INITIAL_STATE = {
    captchaSiteKey: '',
    isCaptchaValid: false
};


// WEBPACK FOOTER //
// ./src/reducers/state/Captcha.js